export const PUBLIC_ROUTE = {
  PAYMENT: "/payment",
};
